const statusList = ['lead', 'customer', 'loyal', 'inactive'].reduce( (acc, name) => {
  acc[name] = name;
  return acc;
}, {});

export default {
  statusList
}
